export interface FacebookButtonsState {
  formEventChildData: {
    valid: boolean;
    dataTosave: any;
    dirty: boolean;
    buttonshow: any;
  } | null;
}

export const initialFacebookButtonsState: FacebookButtonsState = {
  formEventChildData: null,
};
